<template>
    <el-dialog :title="pageTitle" :visible="showDialog" :show-close="false" top="5%">
    <div class="panel-collapse collapse in" aria-expanded="true" id="createFile">
        <div class="content">
            <div class="box box-default box-body">
                <el-form ref="fileForm" :model="fileForm" class="has-disabledField"  :rules="rules">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="订单类型" prop="order_type">
                                <el-select v-model="fileForm.order_type" filterable placeholder="请选择" style="width:100%;" @change="(val) => {return disProduct(val,true)}">
                                    <el-option
                                    v-for="item in orderType"
                                    :key="item.order_type"
                                    :label="item.order_type_str"
                                    :value="item.order_type">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="产品名称" prop="product_id">
                                <el-cascader style="width:100%;" 
                                    :options="productSearchItem" :props="productSearchProps" v-model="fileForm.product_id"
                                     @change="(val) => {return handleOptionData(val,true)}"
                                ></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="申请金额" prop="apply_price">
                                <el-input v-model="fileForm.apply_price" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="申请用途" prop="apply_purpose">
                                <el-radio :label="radio.value" v-for='(radio,key) in applyPurpose' :key='key' v-model="fileForm.apply_purpose">{{radio.label}}</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <h4 class="dialog-item-title">客户信息</h4>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="客户姓名" prop="name">
                                <el-input v-model="fileForm.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="手机号1" prop="phone">
                                <el-input v-model="fileForm.phone"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="手机号2" prop="phone2">
                                <el-input  v-model="fileForm.phone2"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="身份证号" prop="idcard">
                                <el-input v-model="fileForm.idcard" @change="idCardChange"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="性别" prop="sex">
                                <el-select v-model="fileForm.sex" placeholder="请选择" style="width:100%;">
                                    <el-option
                                    v-for="item in userSexItem"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="出生年月" prop="birthday">
                                <el-date-picker
                                    v-model="fileForm.birthday" type="date" placeholder="选择日期" style="width:100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="身份证有效期" prop="idcard_validity">
                                <el-input v-model="fileForm.idcard_validity" placeholder="输入'长期' 或 日期（格式：2000-01-01）"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="户口所在地" prop="resident_address" >
                                <el-input v-model="fileForm.resident_address">
                                    <el-cascader 
                                        :options="cities.list" :props="cities.props" v-model="fileForm.user_cityId"
                                        @active-item-change="(val) => {return citiesItemChange(val,true)}" slot="prepend"
                                    ></el-cascader>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
		        <div slot="footer" class="dialog-footer text-right">
	                <el-button @click="showDialog = false">取 消</el-button>
	                <el-button type="primary" @click="submit" :loading="submitLoading" :disabled="loading">确 定</el-button>
	            </div>
            </div>
        </div>
    </div>
    </el-dialog>
</template>


<script>
import _this from '../../js/form/createFile.js'
import lodash from 'lodash'
let _p = window.xwCommon,
name = _this.name;
    export default{
        name,
        props:{"visible":{type:Boolean, default:false }},
        data(){
            let rules=_this.rules;
            return{
                fileForm : {},
                applyPurpose : [
                    {label : '资金周转',value:'0'},
                    {label : '购物',value:'1'},
                    {label : '其他',value:'2'}
                ],
                pageTitle : _this.title,
                treeLoading: false, 
                loading: false,
                showDialog : false, 
                currDept : undefined,
                loanTypeOnly : false, 
                submitLoading : false, 
                cities: { list:[], props:_p.getStoredProp("_/cities/props") },
                userSexItem : _p.getStoredProp("_/default/sex"),
                productSearchItem : [],
                productSearchProps : { "label":"product_name", "value":"product_id", "children":"childrens" },
                orderType : [],
                rules,
                StoreByArea : [],
                props: {
                    value : "id",
                    label : "name",
                    children : "children"
                },
            }
        },
        methods:{
            citiesItemChange(val,isUser){
                switch(val.length){
                    case 2 :
                    _this.getDistrictList(this,val)
                    return;
                    case 1:
                    _this.getCityList(this, val[0], 2)
                    return;
                    default:
                    this.$alert("无效的选项信息",pageTitle);
                    return;
               }
            },
            handleOptionData(val){
               switch(val.length){
                   case 2 :
                   _this.getApplyPrice(this,val);
                   return;
                   default:
                   return;
               }
            },
            disProduct(val){
                lodash.forEach(this.productSearchItem,(childrens,k) =>{
                    lodash.forEach(childrens.childrens,(j)=>{
                        if(val==4){
                            if(j.product_name=="小微速贷D11_NEW"){
                                j.disabled = true
                                this.fileForm.product_id = []
                            }
                            if(j.product_name=="小微速贷D11_OLD"){
                                j.disabled = false
                            }
                        }else if(val==1){
                            if(j.product_name=="小微速贷D11_OLD"){
                                j.disabled = true
                                this.fileForm.product_id = []
                            }
                            if(j.product_name=="小微速贷D11_NEW"){
                                j.disabled = false
                            }
                        }
                    })
                })
            },
            idCardChange(val){
                this.$set(this.fileForm,"idcard",val.toLocaleUpperCase())
                let info = _p.getIDCardInfo(val)
                if (info) {
                    this.$set(this.fileForm,"sex",info.sex)
                    this.$set(this.fileForm,"birthday",info.birthday)
                }
            },
            submit(){
                this.$refs['fileForm'].validate((val)=>{
                    if(val){
                        _this.submit(this).then((json)=>{
                        this.$emit('closed')
                    }).catch(err=>{
                        this.loading = false;
                        this.$alert(err.toString(),this.pageTitle)
                    })
                    }else{
                        this.$alert('表单存在错误',this.pageTitle);
                    }
                })

            }
        },
        watch:{
            visible:function(val){
                if (val) {
                    _this.initWin(this)
                } else
                    this.showDialog = false
            },
            showDialog:function(val){
                if (!val) this.$emit('closed')
            }
        },
        mounted(){
            // _this.loadBaseNodes(this)
        }
    }
</script>
<style scoped>
.dialog-item-title{
    color: #1F2D3D;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
}
</style>




// WEBPACK FOOTER //
// createFile.vue?2fe5dada